module.exports = __webpack_public_path__ + "img/fe7c8bb.webp";